/** Keep in sync with `PARTNER_COCKPIT_ROUTE_PREFIX` in `apps/nestjs-backend/src/config/config.ts`. */
export const PARTNER_COCKPIT_ROUTE_PREFIX = 'partner-cockpit' as const;

export const PARTNER_COCKPIT_API_PATH_PREFIX = `/${PARTNER_COCKPIT_ROUTE_PREFIX}` as const;

export function partnerCockpitApiPath(suffix: string): string {
    const normalized = suffix.startsWith('/') ? suffix : `/${suffix}`;
    return `${PARTNER_COCKPIT_API_PATH_PREFIX}${normalized}`;
}

const environment = (import.meta.env.VITE_APP_ENVIRONMENT as string | undefined) ?? (import.meta.env.MODE as string);

export const config = {
    apiUrl: import.meta.env.VITE_API_URL,
    codeVersion: import.meta.env.VITE_CODE_VERSION || undefined,
    environment,
    isProductionMode: import.meta.env.MODE === 'production' || import.meta.env.VITE_APP_ENVIRONMENT === 'production',
    isStagingMode: import.meta.env.MODE === 'staging' || import.meta.env.VITE_APP_ENVIRONMENT === 'staging',
    // development is the default mode for Vite
    isDevMode: import.meta.env.MODE === 'development' || import.meta.env.VITE_APP_ENVIRONMENT === 'local',
} as const;
